import { render } from "./MainPointOutcomeChart.vue?vue&type=template&id=27521a67"
import script from "./MainPointOutcomeChart.vue?vue&type=script&lang=js"
export * from "./MainPointOutcomeChart.vue?vue&type=script&lang=js"

import "./MainPointOutcomeChart.vue?vue&type=style&index=0&id=27521a67&lang=css"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MainPointOutcomeChart.vue"]])

export default __exports__